import { phoneNavigationAvailabilityOptions } from '@/features/hestia/queries/usePhoneNavigationAvailability'
import { queryClient } from '@/plugins/queryClient'
import type { HermesGuardFn } from '@/router/guards/types'

const PHONE_ORDERING_ROUTES = new Set([
  'brand.phone',
  'brand.phone.calls',
  'brand.phone.overview',
])

export const checkPhoneOrderingFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !PHONE_ORDERING_ROUTES.has(to.name)) {
    return undefined
  }

  const brandId = to.params.brandId
  const result =
    typeof brandId === 'string'
      ? await queryClient.fetchQuery(
          phoneNavigationAvailabilityOptions(brandId)
        )
      : { rolloutEnabled: false }

  if (!result.rolloutEnabled) {
    return {
      name: 'brand.home',
      params: { brandId },
    }
  }

  return undefined
}
